import React from 'react';

import Snappy from './media/snappyBody.svg';
import LeftHand from './media/leftHand.svg';
import RightHand from './media/rightHand.svg';

import * as Styles from './styles';

export const SnappyAnimation = () => (
  <Styles.Wrapper>
    <Styles.SnappyAnimation src={Snappy} alt="Snappy" />
    <Styles.LeftHand src={LeftHand} alt="Snappy" />
    <Styles.RightHand src={RightHand} alt="Snappy" />
  </Styles.Wrapper>
);
